export class UpdateOrderBuildStepMessage {
  buildStepStatus: number
  
  constructor(buildStepStatus: number) {
    this.buildStepStatus = buildStepStatus
  }
}
      